import jQuery from 'jquery';

export default class CardHeader {
    constructor() {
        this.containerElem = jQuery('.RC-courseTime__content');
        this.blockElem = jQuery('.RC-courseTime');
        this.bindEvents();
        this.setContainerHeight();
    }

    bindEvents() {
        jQuery(window).on('resize', this.setContainerHeight.bind(this));
    }

    setContainerHeight() {
        const containerHeight = this.containerElem.outerHeight();

        this.blockElem.css({
            height: containerHeight
        });
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/cardHeader.js